<template>
  <div class="page-container">
    <AppHeader title="Users Management"/>
    
    <div class="content-wrapper">
      <Void :open="isVoidOpen" @getVoidPermission="setVoidPermission($event)" @close="isVoidOpen = !isVoidOpen" />
      
      <!-- Error Message -->
      <div v-if="showError" class="alert alert-danger text-center">
        {{ this.mainErrorMsg }}
      </div>

      <!-- Action Bar (When listing users) -->
      <div v-if="toggle" class="touch-search-header" style="margin-bottom: 2rem;">
        <div class="touch-search-area">
          <div class="input-group touch-search-group">
            <span class="input-group-addon">
              <i class="glyphicon glyphicon-search"></i>
            </span>
            <input
              type="text"
              v-model="searchUser"
              class="form-control input-lg"
              placeholder="Search users"
              @keyup.enter="applyUserSearch()"
            />
            <span class="input-group-btn">
              <button class="btn btn-success btn-lg" @click="applyUserSearch()">
                Search
              </button>
            </span>
          </div>
        </div>
        <div class="touch-search-actions">
          <button class="btn btn-success btn-lg" @click="handleAddUser">
            <i class="glyphicon glyphicon-plus"></i> New User
          </button>
        </div>
      </div>

      <!-- Users Table -->
      <div v-if="toggle" class="table-container">
        <div class="table-responsive table-wrap">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th>User Name</th>
                <th>Edit</th>
                <th>Permissions</th>
                <th>Duplicate</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in filteredUsers" :key="user.id">
                <td>{{ user.user_name }}</td>
                <td>
                  <button class="btn btn btn-success" @click="editUser(user)" title="Edit">
                    Edit
                  </button>
                </td>
                <td>
                  <button class="btn btn btn-warning" @click="handleOpenPermission(user)" title="Permissions">
                    Permissions
                  </button>
                </td>
                <td>
                  <button class="btn btn btn-secondary  btn-primary" @click="duplicateUser(user)" title="Duplicate">
                    Duplicate
                  </button>
                </td>
                <td>
                  <button class="btn btn btn-danger" @click="deleteUser(user)" title="Delete">
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- User Form (Add/Edit/Duplicate) -->
      <div v-if="showAddPromotion || showDuplicatePromotion" class="form-card">
        <div class="card-header">
          <h3>{{ showDuplicatePromotion ? 'Duplicate User' : (userId === -1 ? 'Create New User' : 'Edit User') }}</h3>
        </div>
        <div class="card-body">
          <div class="form-group">
            <label>User Name</label>
            <input type="text" autocomplete="one-time-code" v-model="user_name" class="form-control custom-input" placeholder="Enter user name">
          </div>
          <div class="form-group">
            <label>Password</label>
            <input type="password" autocomplete="one-time-code" v-model="password" class="form-control custom-input" placeholder="Enter password">
          </div>
          <div class="form-group">
            <label>Repeat Password</label>
            <input type="password" autocomplete="one-time-code" v-model="repeat_password" class="form-control custom-input" placeholder="Confirm password">
          </div>
          
          <div class="form-actions">
             <button class="btn btn-danger" @click="cancelSavePromotion">Cancel</button>
             
             <button v-if="showDuplicatePromotion" class="btn btn-success" @click="DuplicateUserSubmit">
               Duplicate User
             </button>
             
             <template v-else>
               <button v-if="userId === -1" class="btn btn-success" @click="createUser">Create User</button>
               <button v-else class="btn btn-success" @click="updateUser">Update User</button>
             </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import commonServices from "@/shared/commonServices"
import AppHeader from "@/components/AppHeader";
import MainMenu from "@/components/MainMenu";
import Datepicker from 'vuejs3-datepicker';
import 'vue-date-pick/dist/vueDatePick.css';
import Void from "@/components/Void";
import { mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters({
            userPermissions: "modules_options/userPermissions"
        }),
        filteredUsers() {
            let list = this.allUsers || [];
            const search = (this.searchUser || "").toLowerCase();

            if (search) {
                list = list.filter((u) => {
                    const name = (u.user_name || "").toLowerCase();
                    const id = (u.id || "").toString().toLowerCase();
                    return name.includes(search) || id.includes(search);
                });
            }

            return list;
        },
    },
    mixins: [commonServices],
    mounted() {
        this.getAllUsers();
        if (localStorage.userId !== undefined && localStorage.appId !== undefined) {
        } else {
            this.$router.push({ name: 'login' });
        }
        this.language = 'ar';
        this.logoImage = '<img src="' + this.logoUrl + '" width="70" height="50" alt="Logo">';
    },
    components: { MainMenu, Datepicker, Void, AppHeader },
    data: function () {
        return {
            state: { start_date: new Date(2016, 9, 16) },
            stateEnd: { end_date: new Date(2016, 9, 16) },
            showAddPromotion: false,
            showDuplicatePromotion: false,
            promotions: [],
            allUsers: [],
            searchUser: "",
            userJson: {},
            promotionJson: {},
            promotionInfos: {},
            userId: -1,
            promoition_name: '',
            start_date: '',
            end_date: '',
            minimum_total: '',
            percentage: '',
            user_name: '',
            authorizedToChangePrice: 'N',
            isVoidOpen: false,
            password: '',
            repeat_password: '',
            reports_ok: false,
            showError: false,
            logoImage: '',
            mainErrorMsg: '',
            logoUrl: '',
            jsonData: {},
            language: 'en',
            languageName: '',
            toggle: true,
            showInvoices: false,
            showPayments: false,
            addresses: [],
            selectedcustomers: [],
            customer_invoices: [],
            customer_payments: [],
            customersJson: {},
            name: '',
            gender: '',
            email: '',
            phone: '',
            totalpoints: '',
            dis_percentage: '',
            status: '',
            creditstatus: '',
            date_added: '',
            aaddressid: 0,
            addressLine1: '',
            addressLine2: '',
            addressArea: '',
            addressCity: '',
            isDefault: false,
            customerAddresses: [],
            showAddress: false,
            findcustomer: '',
            findcustomername: '',
            customeraddress: {}
        }
    },
    methods: {
        applyUserSearch() {
            this.searchUser = (this.searchUser || "").trim();
        },

        async setVoidPermission(authorizedToChangePrice) {
            if (authorizedToChangePrice === 'Y') {
                this.userJson.appId = localStorage.appId;
                this.userJson.id = this.userId

                try {
                    let dataURL = this.apiURL + 'Users/deleteUser';
                    let response = await axios.post(dataURL, this.userJson);
                    if (response.data.status === 'success') {
                        this.showSuccess("User Deleted Successfully!");
                        this.getAllUsers();
                        this.cancelSavePromotion();
                    } else {
                        this.showAlert("Error Happened Please Check Entered Data!");
                    }

                }
                catch (error) {
                    console.log(error);
                }
            } else {
                // Error message mo permission
            }
            this.authorizedToChangePrice = 'N'
        },
        editUser(user) {
            this.user_name = user.user_name;
            this.userId = user.id;
            this.toggle = false;
            this.showAddPromotion = true;
        },
        duplicateUser(user) {
            this.user_name = user.user_name;
            this.userId = user.id;
            this.toggle = false;
            this.showAddPromotion = false;
            this.showDuplicatePromotion = true;
        },
        handleOpenPermission(user) {
            this.$router.push({ name: 'user-permissions', params: { userId: user.id } });
        },
        deleteUser: function (user) {
            this.isVoidOpen = true;
            this.userId = user.id;
        },
        createUser: async function () {
            if(this.password == '' || this.user_name == ''){
                this.showAlert("Please Fill All fields!");
                return;
            }
            if (this.password != this.repeat_password) {
                this.showAlert("Please Match passwords!");
                return;
            }
            this.userJson.appId = localStorage.appId;
            this.userJson.user_name = this.user_name;
            this.userJson.password = this.password;
            try {
                let dataURL = this.apiURL + 'Users/createUser';
                let response = await axios.post(dataURL, this.userJson);
                if (response.data.status === 'success') {
                    this.showSuccess("User Added Successfully!");
                    this.getAllUsers();
                    this.cancelSavePromotion();
                } else {
                    this.showAlert("Error Happened Please Check Entered Data!");
                }

            }
            catch (error) {
                console.log(error);
            }
        },
        cancelSavePromotion() {
            this.toggle = true;
            this.showAddPromotion = false;
            this.showPermissions = false;
            this.showDuplicatePromotion = false;
        },

        DuplicateUserSubmit: async function () {
            if(this.password == '' || this.user_name == ''){
                this.showAlert("Please Fill All fields!");
                return;
            }
            if (this.password && this.password != this.repeat_password) {
                this.showAlert("Please Match passwords!");
                return;
            }
            this.userJson.appId = localStorage.appId;
            this.userJson.dup_id = this.userId
            this.userJson.user_name = this.user_name;
            this.userJson.password = this.password;

            try {
                let dataURL = this.apiURL + 'Users/duplicateUser';
                let response = await axios.post(dataURL, this.userJson);
                if (response.data.status === 'success') {
                    this.showSuccess("User Duplicated Successfully!");
                    this.getAllUsers();
                    this.cancelSavePromotion();
                } else {
                    this.showAlert("Error Happened Please Check Entered Data!");
                }

            }
            catch (error) {
                console.log(error);
            }
        },
        
        updateUser: async function () {
            if(this.password == '' || this.user_name == ''){
                this.showAlert("Please Fill All fields!");
                return;
            }
            if (this.password && this.password != this.repeat_password) {
                this.showAlert("Please Match passwords!");
                return;
            }
            this.userJson.appId = localStorage.appId;
            this.userJson.id = this.userId
            this.userJson.user_name = this.user_name;
            this.userJson.password = this.password;

            try {
                let dataURL = this.apiURL + 'Users/updateUser';
                let response = await axios.post(dataURL, this.userJson);
                if (response.data.status === 'success') {
                    this.showSuccess("User Updated Successfully!");
                    this.getAllUsers();
                    this.cancelSavePromotion();
                } else {
                    this.showAlert("Error Happened Please Check Entered Data!");
                }

            }
            catch (error) {
                console.log(error);
            }
        },
        
        

        handleAddUser: async function () {
            this.showAddPromotion = true;
            this.userId = - 1;
            this.user_name = '';
            this.password = '';
            this.repeat_password = '';
            this.showError = false;
            this.mainErrorMsg = "";
            this.showAddCustomer = true;
            this.toggle = false;
        },
        getAllUsers: async function () {
            this.userJson.appId = localStorage.appId;
            try {
                let dataURL = this.apiURL + 'Users/getAllUsers';
                let response = await axios.post(dataURL, this.userJson);
                if (response.data.status === 'success') {
                    this.allUsers = response.data.results;
                }
            }
            catch (error) {
                console.log(error);
            }
            return this.allUsers;
        }
    }
}
</script>
<style scoped>
.page-container {
  min-height: 100vh;
  margin-top: -26px;
  background: var(--theme-bg-end);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(1px);
}

.content-wrapper {
  padding: 1rem;
  max-width: 1400px;
  margin: 0 auto;
}

/* Action Bar */
.action-bar {
  margin-bottom: 2rem;
  display: flex;
  justify-content: flex-end;
}

.action-btn {
  font-size: 1.1em;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.2);
  transition: all 0.3s ease;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(0,0,0,0.3);
}

/* Table Styles */
.table-container {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.table-wrap {
  max-height: 70vh;
  border-radius: 8px;
}

.actions-cell .btn-group {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}

.actions-cell .btn {
  border-radius: 4px !important;
  padding: 0.4rem 0.8rem;
  font-size: 0.9em;
}

/* Form Card */
.form-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 2rem;
  max-width: 600px;
  margin: 0 auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.card-header h3 {
  color: var(--theme-text-main);
  margin-bottom: 2rem;
  text-align: center;
  font-weight: 600;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  color: var(--theme-text-muted);
  margin-bottom: 0.5rem;
  font-size: 1.1em;
}

.custom-input {
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  border-radius: 8px;
  padding: 1rem;
  font-size: 1.1em;
  transition: all 0.3s ease;
}

.custom-input:focus {
  background: rgba(0, 0, 0, 0.3);
  border-color: var(--theme-primary);
  box-shadow: 0 0 0 2px rgba(92, 107, 192, 0.2);
  outline: none;
}

.form-actions {
  margin-top: 3rem;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.form-actions .btn {
  flex: 1;
  padding: 1rem;
  font-size: 1.1em;
  border-radius: 8px;
}
</style>
